<template>
  <div>
    <Board
      v-for="(item, index) in voltages"
      :index="index"
      :key="index"
      :boardName="item.BoardName"
      :parameters="item.Parameters"
    >
    </Board>
  </div>
</template>

<script>
import Board from './Board.vue';

export default {
  components: {
    Board,
  },

  props: {
    voltages: Object,
  },

  methods: {
  },
};
</script>
